import { lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { SuspensedView } from '@components/SuspensedView'

import { MasterLayout } from '@/layouts/MasterLayout'

const SalesInvoicesRoutes = lazy(() => import('@/routes/clinic-manager/SalesInvoicesRoutes'))
const ShiftRoutes = lazy(() => import('@/routes/clinic-manager/ShiftRoutes'))

const ClinicManagerRoutes = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route
          path="shifts/*"
          element={
            <SuspensedView>
              <ShiftRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="sales-invoices/*"
          element={
            <SuspensedView>
              <SalesInvoicesRoutes />
            </SuspensedView>
          }
        />

        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
      </Route>
    </Routes>
  )
}

export { ClinicManagerRoutes }
